<template>
    <div>
        <div class="backfround">
            <img :src="loginConfig.userViewLoginBackground" alt="">
        </div>
        <div class="logo">
            <img :src="loginConfig.logo" alt="logo">
        </div>
        <div class="opreation">
          <login-view v-if="!setPwd"></login-view>
          <set-password v-else></set-password>
            <div class="mottoTitle">
                <p>{{ loginConfig.mottoTitle }}</p>
            </div>
            <div class="line"></div>
            <p class="bottom">{{ loginConfig.mottoContent }}</p>
        </div>
    </div>
</template>

<script>

import LoginView from '@/components/loginComponents/LoginView';
import SetPassword from '@/components/loginComponents/SetPassword';
import Auth from '../../utils/auth';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LoginPasswd',
  meta:{page:true},
  components: {
    LoginView,
    SetPassword,
  },
  computed: {
    ...mapGetters('user', {
      loginConfig: 'getLoginConfig',
      loginStatus: 'login'
    })
  },
  data() {
    return {
        setPwd: this.$route.query.setPwd,
    }
  },
  mounted() {
    if(!this.setPwd) {
      this.checkLogin();
    }

  },
  watch: {
  },
  methods: {
    checkLogin () {
      if (Auth.loginUser()) {
        let refer = this.$route.query.refer || '/';
        this.$router.replace({path: refer});
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"  scoped>
  @import "../../assets/scss/login.scss";

.forget {
    font-size: .1rem;
}
.save {
    margin-top: 8px;
}

.mottoTitle p {
  color: #009688;
}
.line {
    background: #009688;
}
.bottom {
    color: #7F7F7F;
}
</style>




// WEBPACK FOOTER //
// src/components/page/LoginPasswd.vue